export default __webpack_public_path__ + "static/media/datils.88db9fb9.jpg";